import React, { useState, useContext, memo, useEffect } from "react";
import {
  StyleSheet,
  View,
  TouchableOpacity,
  Dimensions,
  Text,
} from "react-native";
import CustomText from "../accessories/CustomText";
import {
  handleAPI,
  handleLogDWCallToActionEventParent,
  queryStringToObject,
  updateWebURL,
} from "../accessories/CommonFunctions";
import { context } from "../accessories/accessories";
import { REDIRECT_URL } from "@env";
import { web } from "../accessories/Platform";
import ArrowSpinner from "../accessories/ArrowSpinner";

const isMobileWeb = Dimensions.get("window").width <= 480,
  screenSize = web ? [window.innerWidth, window.innerHeight] : [0, 0],
  isSmallScreen =
    (web && screenSize[0] > 900) || Dimensions.get("window").width > 900,
  width =
    (!isMobileWeb && web) || (!web && isSmallScreen)
      ? 700
      : Dimensions.get("window").width - 30;

const Spinner = memo(() => (
  <View
    style={{
      alignSelf: "center",
      justifyContent: "center",
      alignItems: "center",
      flex: 1,
    }}
  >
    <View
      style={{
        width: 90,
        textAlign: "center",
        flexDirection: "row",
        justifyContent: "center",
      }}
    >
      <ArrowSpinner
        size={15}
        style={{
          flex: web ? "unset" : 1,
          margin: 0,
          top: !web ? 4 : 0,
          marginRight: web ? 5 : 0,
        }}
      />
      <CustomText>Loading...</CustomText>
    </View>
  </View>
));

export default function TaskTable(props) {
  const { contextDetails, setContextDetails } = useContext(context); //Get value from context
  const { navigation, userName = "", SessionId = "" } = contextDetails;
  const {
    setWebPageURL,
    tab,
    rowData: iRowData,
    setFloatPage = () => {},
  } = props; //updateTaskDetails

  const [rowData, setRowData] = useState(iRowData || []);

  useEffect(() => {
    if (
      (rowData || []).length > 0 &&
      !contextDetails["iLoanId"] &&
      props["tab"] === "activeRowData"
    ) {
      setContextDetails({
        ...contextDetails,
        iLoanId: rowData[0].loanid,
      });
    }
  }, [rowData]);

  useEffect(() => {
    setRowData(iRowData);
  }, [iRowData]);

  const handleRedirectURL = async (Link, FormId, row) => {
    console.log({ Link, FormId, row });

    let URL = "",
      Path = "Home",
      loanId = row["loanid"] === 0 ? -999 : row["loanid"] || -999,
      GoToNav = 0;
    if (Link === 9) {
      if (web) {
        setFloatPage({
          path: "Payment",
          option: {
            From: "DashBoard",
            LoanId: row["loanid"],
            SessionId,
            UserId: 0,
            style: {
              minHeight: "75vh",
            },
          },
        });
        return;
      } else {
        (navigation || props["navigation"]).navigate("Payment", {
          From: "DashBoard",
          LoanId: row["loanid"],
          SessionId,
          UserId: 0,
        });
      }
      return;
    } else if (Link == 4) {
      // handleCreateLoanOnly(SessionId, navigation, userName);
      setContextDetails((prevContextDetails) => {
        return { ...prevContextDetails, loanId: -999, Path };
      });
      updateWebURL({
        SessionId: SessionId,
        loanId: -999,
        Path,
      });
      (navigation || props["navigation"]).navigate("Home", {
        userName: userName,
        SessionId: SessionId,
        loanId: -999,
      });
    }
    if (Link == 7) {
      URL = `${REDIRECT_URL}rates/rates-wizard.php?SessionId=${SessionId}&GatherId=0&From=borwelcomepage&RateQuoteId=36297&LoanOfficerId=1`;
    } else {
      if (Link == 6) {
        GoToNav = parseInt(FormId) === 17 ? 5 : parseInt(FormId) === 34 ? 9 : 0;
        //GoToNav == 5 =>> Credit Report
        //GoToNav == 9 =>> Doc Upload
      } else if (Link == 8 || Link === 1) {
        if (
          row["TaskAssigned"].includes("Review Your Interest Rate")
          //&& loanURLDetails["apprURL"]
        ) {
          GoToNav = 12;
          //GoToNav == 12 =>> Int Rate
        } else {
          GoToNav = 11;
          //GoToNav == 11 =>> App Payment
        }
        // });
      } else if (Link === 0) {
        GoToNav = 10;
        //GoToNav == 10 =>> E-Sign
      }

      await setContextDetails((prevContextDetails) => {
        return { ...prevContextDetails, loanId, Path: "Home" };
      });
      let Publicpage = 0;
      if (FormId == 34) {
        Publicpage = 1;
      }
      let params = {
        FormId,
        loanId,
        Path,
        GoToNav,
        Publicpage,
      };

      (navigation || props["navigation"]).navigate(Path, params);

      if (web) updateWebURL(params);
    }

    if (URL !== "") {
      setWebPageURL(URL);
    }

    handleLogDWCallToActionEventParent(
      row["TaskAssigned"],
      "fnLogDWCallToActionEvent",
      "Borrower Loan Application",
      {
        SessionId,
        Email: "",
        LoanId: row["loanid"],
        LoanOfficerId: web
          ? queryStringToObject(window.location?.href || "")["loanOfficerId"] ||
            contextDetails.RecentLoId ||
            0
          : contextDetails.RecentLoId || 0,
        Email: contextDetails["Email"],
      }
    );
  };

  return (
    <View style={styles.container}>
      {(rowData || []).length > 0 ? (
        <>
          {(rowData || []).map((row, index, arr) => (
            <TouchableOpacity
              key={index}
              style={[
                styles.row,
                index == arr.length - 1
                  ? { borderBottomLeftRadius: 5, borderBottomRightRadius: 5 }
                  : {},
              ]}
              activeOpacity={0.5}
              onPress={() => {
                let FormId = Number(row["formids"]);

                if (FormId === 666) handleRedirectURL(4, FormId, row);
                else if (FormId === 668) handleRedirectURL(7, FormId, row);
                else if (FormId === 669) handleRedirectURL(8, FormId, row);
                else if (FormId === 122) handleRedirectURL(0, FormId, row);
                else if (FormId === 138) handleRedirectURL(1, FormId, row);
                else if (FormId === 667) handleRedirectURL(0, FormId, row);
                else if (FormId === 945) handleRedirectURL(9, FormId, row);
                else handleRedirectURL(6, FormId, row);
              }}
            >
              <View style={{ flexDirection: "row", flex: 1 }}>
                <CustomText
                  style={{
                    ...{
                      marginLeft: 0,
                      color: "#1172c1",
                      paddingVertical: 12,
                      fontSize: !isMobileWeb && web ? 16 : null,
                      flex: 1,
                      flexWrap: "wrap",
                    },
                    ...(web ? { cursor: "pointer" } : {}),
                  }}
                >
                  {row["TaskAssigned"]}
                </CustomText>
              </View>
            </TouchableOpacity>
          ))}
        </>
      ) : (
        <>
          <View
            style={[
              styles.row,
              { borderBottomLeftRadius: 5, borderBottomRightRadius: 5 },
            ]}
          >
            {tab === "completeRowData" ? (
              <>
                <CustomText
                  style={{
                    height: 35,
                    padding: 10,
                    fontSize: !isMobileWeb && web ? 16 : 14,
                  }}
                >
                  There are no completed Tasks.
                </CustomText>
              </>
            ) : props["rowData"] === null ? (
              <Spinner />
            ) : (
              <CustomText
                style={{
                  // height: 35,
                  padding: 10,
                  fontSize: !isMobileWeb && web ? 16 : 14,
                }}
              >
                No Active Tasks were found. We'll send you a notification if
                anything else is needed.
              </CustomText>
            )}
          </View>
        </>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#fff",
    borderTopWidth: 1,
    borderTopColor: "#e4e6e9",
    width: width,
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
  },
  head: {
    height: 40,
    backgroundColor: "#f2f4f6",
    flexDirection: "row",
    paddingVertical: 10,
    paddingHorizontal: 15,
    borderBottomWidth: 0.5,
    borderBottomColor: "#999",
    justifyContent: "space-around",
  },

  text: { paddingHorizontal: 10 },
  row: {
    flexDirection: "row",
    backgroundColor: "#fff",
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#e4e6e9",
    paddingHorizontal: 15,
    // height: 45,
  },
  emptyRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#e4e6e9",
    paddingVertical: 8,
    paddingHorizontal: 10,
  },
});
